import React, {useState} from 'react'
import {elastic} from '../../HOC/Elastic/ElasticHOC'
import {SearchOutlined} from '@ant-design/icons'
import SchedulingMap from '../SchedulingMap'
import Projects from '../Projects'
import {Button, Input} from 'antd'
import useGenerateQuery from './useGenerateQuery'
import useLoadSchedule from './useLoadSchedule'

export function RightPanel(props) {
  console.log('RightPanel renders',props)
  const {single} = props
  const [mapToggle, setMapToggle] = useState(true)
  // single means when we click on schedule intake button from projectdetail page it sends id and we pass it here , its a project id from project detail page 
  const setTerm = useGenerateQuery(props)
  useLoadSchedule(single) 


  return (
    <div>
      <div className="flex-row padding-1">
        {!single && <Button onClick={() => setMapToggle(!mapToggle)}> {mapToggle ? 'Project List' : 'Map'}</Button>}
        <div className="padding-1"></div>
        {!single && (
          <Input onPressEnter={(e) => setTerm(e.target.value)} prefix={<SearchOutlined />} placeholder="Search" />
        )}
      </div>
      {/* the map has to stay in the DOM or it resets the center point to whatever the default is */}
      <div style={mapToggle ? {visibility: 'visible'} : {visibility: 'hidden', height: 0}}>
         <SchedulingMap /> 
      </div>
      {!mapToggle && <Projects single={single} />}
    </div>
  )
}

const WrappedRightPanel = elastic(RightPanel)
export default WrappedRightPanel
